import React, { useEffect, useState } from "react";
import "../styles/Portraits.css";

// Cargar todas las imágenes de la carpeta automáticamente y ordenarlas numéricamente y alfabéticamente
const importAll = (r) =>
  r
    .keys()
    .map((fileName) => ({
      src: r(fileName),
      name: fileName.replace('./', ''), // Obtener solo el nombre del archivo
    }))
    .sort((a, b) => {
      const numA = a.name.match(/\d+/); // Extraer el número del nombre del archivo
      const numB = b.name.match(/\d+/); // Extraer el número del nombre del archivo

      if (numA && numB) {
        return parseInt(numA[0]) - parseInt(numB[0]);
      }

      return a.name.localeCompare(b.name);
    });

const images = importAll(require.context('../img/documentary-webp/', false, /\.(jpg|jpeg|png|webp)$/));

const Documentary = () => {
  const [clickedImageIndex, setClickedImageIndex] = useState(null);

  useEffect(() => {
    const thumbnails = document.querySelectorAll(".thumbnail");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setTimeout(() => {
              entry.target.classList.add("appear");
            }, Math.random() * 500);
          }
        });
      },
      { threshold: 0.6 }
    );

    const handleImageLoad = () => {
      thumbnails.forEach((img) => observer.observe(img));
    };

    thumbnails.forEach((img) => {
      img.addEventListener('load', handleImageLoad);
    });

    return () => {
      thumbnails.forEach((img) => {
        observer.unobserve(img);
        img.removeEventListener('load', handleImageLoad);
      });
    };
  }, []);

  const handleImageClick = (index) => {
    setClickedImageIndex(index);
  };

  const handleCloseClick = () => {
    setClickedImageIndex(null);
  };

  const handleKeyPress = (e) => {
    if (clickedImageIndex !== null) {
      if (e.key === "ArrowRight") {
        // Avanza a la siguiente imagen
        setClickedImageIndex((prevIndex) => (prevIndex + 1) % images.length);
      } else if (e.key === "ArrowLeft") {
        // Retrocede a la imagen anterior
        setClickedImageIndex((prevIndex) =>
          prevIndex === 0 ? images.length - 1 : prevIndex - 1
        );
      } else if (e.key === "Escape") {
        // Cierra la imagen
        handleCloseClick();
      }
    }
  };

  useEffect(() => {
    if (clickedImageIndex !== null) {
      window.addEventListener("keydown", handleKeyPress);
    } else {
      window.removeEventListener("keydown", handleKeyPress);
    }

    return () => {
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, [clickedImageIndex]);

  const handleNextImage = (e) => {
    e.stopPropagation(); // Evitar que el clic cierre la imagen
    setClickedImageIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const handlePrevImage = (e) => {
    e.stopPropagation(); // Evitar que el clic cierre la imagen
    setClickedImageIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  return (
    <div>
      <div className="gallery-header">
        <h1 className="gallery-title">DE BARRIOS</h1>
        <p className="gallery-text">
          I've been taking these portraits for more than eight years. <br></br>
          For more information, we can go for a drink, I'm still working on it.
        </p>
      </div>

      <div className="portraits-container">
        {images.map((image, index) => (
          <div key={index} className="image-wrapper">
            <img
              src={image.src}
              alt={`Documentary ${index + 1}`}
              className="thumbnail"
              onClick={() => handleImageClick(index)}
            />
          </div>
        ))}
      </div>

      {clickedImageIndex !== null && (
        <div className="overlay" onClick={handleCloseClick}>
          <img
            src={images[clickedImageIndex].src}
            alt="Enlarged"
            className="enlarged-image"
          />

          {/* Botones de navegación izquierda y derecha */}
          <button
            className="nav-button prev-button"
            onClick={(e) => handlePrevImage(e)}
          >
            &#10094; {/* Flecha izquierda */}
          </button>
          <button
            className="nav-button next-button"
            onClick={(e) => handleNextImage(e)}
          >
            &#10095; {/* Flecha derecha */}
          </button>
        </div>
      )}
    </div>
  );
};

export default Documentary;
